import { render, staticRenderFns } from "./PermissionAdd.vue?vue&type=template&id=277a7554&scoped=true&"
import script from "./PermissionAdd.vue?vue&type=script&lang=js&"
export * from "./PermissionAdd.vue?vue&type=script&lang=js&"
import style0 from "./PermissionAdd.vue?vue&type=style&index=0&id=277a7554&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277a7554",
  null
  
)

export default component.exports